<script lang="ts">
	import { location } from 'svelte-spa-router';

	const navItems = [
		{ name: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
		{ name: 'Users', path: '/dashboard/users', icon: 'users' },
		{ name: 'Repositories', path: '/dashboard/repositories', icon: 'repos' },
		{ name: 'Sessions', path: '/dashboard/sessions', icon: 'sessions' },
		{ name: 'Payments', path: '/dashboard/payments', icon: 'payments' },
		{ name: 'Search', path: '/dashboard/search', icon: 'search' }
	];

	function isActive(path: string) {
		return $location === path;
	}
</script>

<aside class="sidebar">
	<div class="sidebar-header">
		<h2>Admin Panel</h2>
	</div>

	<nav class="sidebar-nav">
		{#each navItems as item}
			<a
				href="#{item.path}"
				class="nav-item"
				class:active={isActive(item.path)}
			>
				<span class="nav-icon">
					{#if item.icon === 'dashboard'}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<rect x="3" y="3" width="7" height="7"></rect>
							<rect x="14" y="3" width="7" height="7"></rect>
							<rect x="14" y="14" width="7" height="7"></rect>
							<rect x="3" y="14" width="7" height="7"></rect>
						</svg>
					{:else if item.icon === 'users'}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
							<circle cx="9" cy="7" r="4"></circle>
							<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
							<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
						</svg>
					{:else if item.icon === 'repos'}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
						</svg>
					{:else if item.icon === 'sessions'}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<circle cx="12" cy="12" r="10"></circle>
							<polyline points="12 6 12 12 16 14"></polyline>
						</svg>
					{:else if item.icon === 'payments'}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
							<line x1="1" y1="10" x2="23" y2="10"></line>
						</svg>
					{:else if item.icon === 'search'}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<circle cx="11" cy="11" r="8"></circle>
							<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
						</svg>
					{/if}
				</span>
				<span class="nav-text">{item.name}</span>
			</a>
		{/each}
	</nav>
</aside>

<style>
	.sidebar {
		width: 260px;
		background: var(--bg-secondary, #161b22);
		border-right: 1px solid var(--border-primary, #30363d);
		display: flex;
		flex-direction: column;
		height: calc(100vh - 60px);
		position: sticky;
		top: 60px;
	}

	.sidebar-header {
		padding: 1.5rem;
		border-bottom: 1px solid var(--border-primary, #30363d);
	}

	.sidebar-header h2 {
		margin: 0;
		font-size: 1.25rem;
		font-weight: 600;
		color: var(--text-primary, #e6edf3);
	}

	.sidebar-nav {
		flex: 1;
		padding: 1rem 0;
		overflow-y: auto;
	}

	.nav-item {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		padding: 0.75rem 1.5rem;
		color: var(--text-secondary, #8b949e);
		text-decoration: none;
		transition: all 0.2s ease;
		border-left: 3px solid transparent;
	}

	.nav-item:hover {
		background: var(--bg-tertiary, #1c2128);
		color: var(--text-primary, #e6edf3);
	}

	.nav-item.active {
		background: var(--bg-tertiary, #1c2128);
		color: var(--accent-primary, #58a6ff);
		border-left-color: var(--accent-primary, #58a6ff);
	}

	.nav-icon {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.nav-text {
		font-size: 0.9375rem;
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.sidebar {
			display: none;
		}
	}
</style>
